import { LabelWithValue } from '@/components/common/LabelWithValue';
import { formatDisplayDateTime } from '@/utils/date';
import {
  PCMP_DISBURSEMENT_ACK_TONE,
  PCMP_DISBURSEMENT_CONFIRM_LABELS,
  PCMP_DISBURSEMENT_VERIFY_LABELS,
} from '../../constants/pcmpDisburseVerify.constants';
import type { PcmpPayoutAcks } from '../../types/pcmpProposal.types';
import { PcmpProposalSection } from '../PcmpProposalDetail/PcmpProposalSection';
import { PcmpStatusPill } from '../PcmpProposalDetail/PcmpStatusPill';

interface PcmpPayoutAcksCardProps {
  payout: PcmpPayoutAcks;
  /** The submitting MO, the only one who confirms. */
  moName: string | null;
}

/**
 * The MO's confirmation (Accounts payouts, LDS-747) and MIS's verification
 * (either channel, LDS-770) of the payout. Who verified is on the timeline.
 */
export function PcmpPayoutAcksCard({ payout, moName }: PcmpPayoutAcksCardProps) {
  const { confirmation, verification } = payout;
  if (!confirmation && !verification) return null;

  return (
    <PcmpProposalSection title="Disbursement Confirmation">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        {confirmation ? (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <LabelWithValue label="MO Confirmation">
              <PcmpStatusPill tone={PCMP_DISBURSEMENT_ACK_TONE[confirmation.status]}>
                {PCMP_DISBURSEMENT_CONFIRM_LABELS[confirmation.status]}
              </PcmpStatusPill>
            </LabelWithValue>
            <LabelWithValue label="Confirmed at">
              {confirmation.at ? formatDisplayDateTime(confirmation.at) : null}
            </LabelWithValue>
            <LabelWithValue label="Confirmed by">
              {confirmation.byUserId === null ? null : moName}
            </LabelWithValue>
            <LabelWithValue label="Remarks">{confirmation.remarks}</LabelWithValue>
          </div>
        ) : null}
        {verification ? (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <LabelWithValue label="MIS Verification">
              <PcmpStatusPill tone={PCMP_DISBURSEMENT_ACK_TONE[verification.status]}>
                {PCMP_DISBURSEMENT_VERIFY_LABELS[verification.status]}
              </PcmpStatusPill>
            </LabelWithValue>
            <LabelWithValue label="Verified at">
              {verification.at ? formatDisplayDateTime(verification.at) : null}
            </LabelWithValue>
            <LabelWithValue label="Remarks">{verification.remarks}</LabelWithValue>
          </div>
        ) : null}
      </div>
    </PcmpProposalSection>
  );
}
